import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { ModelGroupDropdownComponent }         from '../../components/DomainData/ModelGroupDropdown.component';
import { EquipmentGraphicsMultiSelectComponent }         from '../../components/DomainData/EquipmentGraphicsMultiSelect.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-model-edit',
  templateUrl: './ModelEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => ModelEditComponent)}]
})
export class ModelEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(ModelGroupDropdownComponent) public modelGroupDropdown: ModelGroupDropdownComponent;
    @ViewChild(EquipmentGraphicsMultiSelectComponent) public equipmentGraphicsMultiSelect: EquipmentGraphicsMultiSelectComponent;

    @Input() public record: ent.Model;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'name' : '',
          'modelGroup' : '',
          'materialNumber' : '',
          'conaModelGroup' : '',
          'allowTopper' : '',
          'requireCoolerDoor' : '',
          'requireApproval' : '',
          'numberOfFlavorsRequired' : '',
          'inactive' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        this.modelGroupDropdown.loadOnDemand();
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    modelGroupChange(event: any){
        
        this.record.ModelGroupID = event;
    }
}